import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'

function Preloader() {
    return (
        <div data-pointer="wallet_id_modal_preloader">
            <div className={styles.icon}>
                <Loader borderRadius="m" width={180} height={180} />
            </div>
            <div className={styles.title}>
                <Loader width={261} height={39} />
            </div>
            <div className={styles.subtitle}>
                <Loader width={85} height={24} />
            </div>

            {Array.from({ length: 3 }).map((_, index) => (
                <div key={index} className={styles.item}>
                    <div className={styles.bullet}>
                        <Loader width={30} height={30} />
                    </div>
                    <div>
                        <Loader width={163} height={21} />
                        <Loader width={360} height={18} />
                        <Loader width={360} height={18} />
                        <Loader width={360} height={18} />
                    </div>
                </div>
            ))}

            <div className={styles.button}>
                <Loader borderRadius="m" width="100%" height={18} />
            </div>
        </div>
    )
}

export default Preloader
